import imageAssets from '../data/imageAssets.json';

export const getImageUrl = (source) => imageAssets[source]?.original || source;

export const getThumbnailUrl = (source) => imageAssets[source]?.thumbnail || source;
